/**
 * Created by ZhangJunPeng on 2017/5/19.
 */

import request from '../utils/request';

export const getCalenderDataFuc = searchInfo => {
  return request(
    `/smartmeeting/smart/third/findCalMeeting?roomName=${
      searchInfo.roomName ? encodeURIComponent(searchInfo.roomName) : ''
    }&userId=${searchInfo.userId}&startTime=${searchInfo.startTime}&type=${
      searchInfo.type
    }&zoneIds=${searchInfo.zoneIds}&roomIds=${
      searchInfo.roomIds
    }&deviceIds=${searchInfo.deviceIds ||
      ''}&teaIds=${searchInfo.teaIds}&pageNo=${searchInfo.pageNo}&pageSize=${
      searchInfo.pageSize
    }&lang=${searchInfo.locale}&number=${searchInfo.peopleNum || '1'}`
  );
};

export const getZoneTreeData = searchInfo => {
  const url =
    `/smartmeeting/smart/zone/v2/findAllZone`;
  return request(url, {
    method: 'POST',
    body: JSON.stringify({
      lang: searchInfo.locale,
      pageNo: searchInfo.pageNo || '',
      pageSize: searchInfo.pageSize || '',
      flag: searchInfo.flag || '',
      name: searchInfo.name || '',
      capacity: searchInfo.capacity || '',
      deviceIds: searchInfo.deviceIds || '',
      teaIds: searchInfo.teaIds || '',
      otherRoomIds: searchInfo.otherRoomIds,
      startTime: searchInfo.startTime,
      endTime: searchInfo.endTime,
      audit: searchInfo.audit || '',
      exceptCpties: searchInfo.exceptCpties || ''
    })
  });
};

export const getExternal = locale => {
  return request(`/iwork/external/getAllUser?lang=${locale}`);
};

export const getUserList = locale => {
  return request(`/iwork/userInfo/getAllUser?lang=${locale}`);
};

export const bookingMeetingFuc = ({ locale, meeting }) => {
  const url = `/iwork/reservation/v2/reserSubmit?lang=${locale}`;
  return request(url, {
    method: 'POST',
    body: JSON.stringify(meeting.meeting)
  });
};

export const sendMeetingNotice = meetingId => {
  const url = `/smartmeeting/smart/third/sendMeetingNotice?meetingId=${meetingId}`;
  return request(url, { method: 'POST' });
};

export const cancerMeetingFuc = ({ meetingId, type, userId, locale }) => {
  return request(
    `/smartmeeting/smart/third/cancelMeeting?lang=${locale}&meetingId=${meetingId}&userId=${userId}&type=${type}`
  );
};

export const saveExternalFuc = ({ external, locale }) => {
  const url = `/iwork/external/saveUser?lang=${locale}`;
  return request(url, {
    method: 'POST',
    body: JSON.stringify({
      userName: external.userName,
      mobile: external.mobile,
      email: external.email
    })
  });
};

/**
 * 通过部门查询用户
 * @param payload
 * @param locale
 * @returns {Object}
 */
export const findUsersByDeptCode = (payload, locale) => {
  return request(
    `/iwork/userInfo/findUsersByDept?lang=${locale}&nodeCode=${
      payload.nodeCode
    }&page=${payload.page}&rows=${payload.rows}`
  );
};

export const getAllUserBySearch = (payload, locale) => {
  return request(
    `/iwork/userInfo/getAllUserBySearch?lang=${locale}&status=0&term=${encodeURIComponent(
      payload.term
    )}&position=${encodeURIComponent(payload.position)}&page=${
      payload.page
    }&rows=${payload.rows}`
  );
};

export const getRoomDetail = ({ roomId, locale }) => {
  const uri = `/smartmeeting/smart/third/findRoomDetail?roomId=${roomId}&lang=${locale}`;
  return request(uri);
};

export const getAllDeptment = ({ lang }) => {
  return request(`/iwork/dept/findDeptTrees?lang=${lang}`);
};

export const getHolidayInfo = () => {
  const uri = `/smartmeeting/smart/holiday/getAllHolidayByTwoYear`;
  return request(uri);
};



// WEBPACK FOOTER //
// ./src/services/calender.js